
import React, { Suspense, useState, useEffect, useRef } from 'react';
import { Route, Routes } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import layoutJSON from "./layout.json";
import UserMangment from '../../pages/user managment/UserManagment';
import Contentmanagement from '../../pages/Content management/Contentmanagement';
import SessionMangment from '../../pages/Session Mangment/SessionMangment';
import CommunityMangment from '../../pages/Coummunity Mangment/CommunityMangment';
import PaymentsAndTransactions from '../../pages/Payments & Transactions/PaymentsAndTransactions';
import AdsAndPromotation from '../../pages/Ads And Promotation/AdsAndPromotation';
import CertificateMangment from '../../pages/Certificate Mangment/CertificateMangment';
import ReferalRewardMangment from '../../pages/Referal Reward/ReferalRewardMangment';
import PreferenceMangment from '../../pages/Preference Mangment/PreferenceMangment';
import AdminMangment from '../../pages/Admin/AdminMangment';
import AppSetting from '../../pages/App Setting/AppSetting'; 
import Questions from '../../pages/question/Question'; 
import TeachersSubscription from '../../pages/TeachersSubscription/TeachersSubscription';
import TeachersWithdrawal from '../../pages/TeachersWithdrawal/TeachersSubscription';
import ViewWithdrawList from '../../pages/TeachersWithdrawal/ViewWithdrawList';
import ViewSubscription from '../../pages/TeachersSubscription/ViewSubscription';
import ViewCommunity from '../../pages/Coummunity Mangment/ViewCommunity';
const Dashboard = React.lazy(() => import("../../pages/dashboard/Dashboard"));
const Analytics = React.lazy(() => import("../../pages/Analytics & reports/Analytics"));
const Helpsupport = React.lazy(() => import("../../pages/Help & support/Helpsupport"));
const Notification = React.lazy(() => import("../../pages/Notifications/Notification"));

function Layout() {
  const [navbarOpen, setNavbarOpen] = useState(true);
  const sidebarRef = useRef(null);
  const [adminData, setAdminData] = useState(null);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1025) {
        setNavbarOpen(false);
      } else {
        setNavbarOpen(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth < 1025 &&
        navbarOpen
      ) {
        const isMenuButton = event.target.closest('[aria-label="Toggle sidebar"]');
        if (!isMenuButton) {
          setNavbarOpen(false);
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [navbarOpen]);

  const handleNavbar = () => {
    setNavbarOpen(!navbarOpen);
  };

  const closeSidebar = () => {
    if (window.innerWidth < 1025) {
      setNavbarOpen(false);
    }
  };

  useEffect(() => {
    try {
      const storedAdminData = localStorage.getItem("adminData");
      if (storedAdminData && typeof storedAdminData === "string") {
        setAdminData(JSON.parse(storedAdminData));
      }
    } catch (error) {
      console.error("Error parsing admin data from localStorage", error);
    }
  }, []);

  const routesList = [
    { path: "/dashboard", element: <Dashboard />, access: "dashboard_analytics" },
    { path: "/users", element: <UserMangment />, access: "user_management" },
    { path: "/content", element: <Contentmanagement />, access: "course_management" },
    { path: "/session", element: <SessionMangment />, access: "sessiion_management" },
    { path: "/community", element: <CommunityMangment />, access: "community_management" },
    { path: "/payments&transactions", element: <PaymentsAndTransactions />, access: "payement_moderation" },
    { path: "/adsAndPromotation", element: <AdsAndPromotation />, access: "Ads_management" },
    { path: "/certificate", element: <CertificateMangment />, access: "certificate_management" },
    { path: "/referal/reward", element: <ReferalRewardMangment />, access: "reward_management" },
    { path: "/preferencepanagement", element: <PreferenceMangment />, access: "preference_management" },
    { path: "/admin", element: <AdminMangment />, access: "admin_management" },
    { path: "/appSetting", element: <AppSetting />, access: "setting_management" },
    { path: "/questions", element: <Questions />, access: "setting_management" },
    { path: "/analytics", element: <Analytics />, access: "dashboard_analytics" },
    { path: "/notifications", element: <Notification />, access: "notification_management" },
    { path: "/helpsupport", element: <Helpsupport />, access: "support_management" },
    { path: "/teachers-subscription", element: <TeachersSubscription />, access: "teachers_subscription" },
    { path: "/teachers-subscription/:id", element: <ViewSubscription />, access: "teachers_subscription" },
    { path: "/teachers-withdrawal", element: <TeachersWithdrawal />, access: "teachers_withdrawal" },
    { path: "/teachers-withdrawal/:id", element: <ViewWithdrawList />, access: "teachers_withdrawal" },
    { path: "/community/:id", element: <ViewCommunity />, access: "community_management" },
  ];
  const filteredSidebarData = routesList.filter(item => adminData?.isMain || adminData?.access?.includes(item.access));

  return (
    <div className="flex h-screen overflow-hidden bg-gray-100">
      <div
        ref={sidebarRef}
        className={`
          fixed lg:relative z-30 h-full transition-all duration-300 ease-in-out
          ${navbarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'} 
          ${navbarOpen ? 'w-64' : 'w-0 lg:w-0'}
        `}
        style={{ height: '100vh' }}
      >
        <Sidebar
          SidebarJSON={layoutJSON.sidebarJSON}
          navbarOpen={navbarOpen}
          setNavbarOpen={setNavbarOpen}
          closeSidebar={closeSidebar}
        />
      </div>

      {navbarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      <div className="flex flex-col flex-1 w-full overflow-hidden">
        <Header HeaderJSON={layoutJSON.headerJSON} handleNavbar={handleNavbar} />
        <main className="flex-1 overflow-y-auto">
          <div className="p-4">
            <Suspense fallback={
              <div className="flex items-center justify-center h-64">
                <div className="w-10 h-10 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
              </div>
            }>
              <Routes>
                {filteredSidebarData.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
              </Routes>
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;